import React from "react";

export const TriggerObserver = React.forwardRef((_, ref) => {
  return <div ref={ref} />;
});

export const CreateThisReference = (setShow) => {
  const ref = React.useRef(null);
  const [loaded, setLoaded] = React.useState(false);

  // React.useEffect(() => {
  //   if (!loaded) {
  //     setTimeout(() => {
  //       setLoaded(true);
  //     }, 500);
  //     return;
  //   }
  // }, []);
  return (post) => {
    if (ref.current) ref.current.disconnect();

    ref.current = new IntersectionObserver((entries) => {
      if (entries[0].intersectionRatio === 0) {
        setShow(false);
      } else {
        setShow(true);
      }
    });

    if (post) ref.current.observe(post);
  };
};

export const ButtonScrollObserver = React.memo(({ render }) => {
  const [open, setOpen] = React.useState(false);
  const [last, setLast] = React.useState(false);

  const refContent = React.useRef(null);

  React.useEffect(() => {
    const findLastElement = document.getElementById("last-element");
    if (findLastElement) {
      const observer = new IntersectionObserver((entries) => {
        if (entries[0].intersectionRatio === 0) {
          setLast(false);
        } else {
          setLast(true);
        }
      });
      observer.observe(findLastElement);
      return () => observer.unobserve(findLastElement);
    }
  }, []);

  return (
    <React.Fragment>
      <div ref={refContent} className="w-full bg-white">
        {render}
      </div>

      <TriggerObserver ref={CreateThisReference(setOpen)} />
      {!open && !last && (
        <div className={` fixed z-40 bottom-0 w-full bg-white shadowbottom `}>
          {render}
        </div>
      )}
    </React.Fragment>
  );
});
